import React from 'react';
import { connect } from 'react-redux';
import { toggleLoading } from '../../Redux/Actions/Loading';

const HourConfig = ({ servertTime, nextDayTime, onToggleLoading }) => {
  // const [time, setTime] = useState(nextDayTime);

  // useEffect(() => {
  //   setTime(nextDayTime);
  // }, [nextDayTime]);

  // const setNextDayTime = () => {
  //   onToggleLoading();
  //   const patt = new RegExp('^([0-1][0-9]|2[0-3]):[0-5][0-9]$');
  //   if (patt.test(time)) {
  //     axios
  //       .put('/api/v1/configs/display_next_day_time', {
  //         object: { value: time },
  //       })
  //       .then(() => {
  //         onToggleLoading();
  //       })
  //       .catch(e => {
  //         onToggleLoading();
  //         toast.error(`Impossible de mettre à jour la configuration`);
  //       });
  //   } else {
  //     alert(
  //       "L'heure doit être doit être sous ce format: 05:00 ou encore 18:00.",
  //     );
  //   }
  // };

  return (
    <div className="content-box">
      <h3 className="content-box-header bg-default">
        <i className="glyph-icon icon-cog" />
        Configuration
      </h3>
      <div className="content-box-wrapper">
        <div className="row">
          <div className="col-md-12">
            <p>Heure serveur:</p>
            <p>{servertTime}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  onToggleLoading: () => dispatch(toggleLoading()),
});

export default connect(
  null,
  mapDispatchToProps,
)(HourConfig);
